import React, { useEffect } from "react";
import ReactDOM from 'react-dom';
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";
import $ from "jquery"; // Import jQuery
import CustomNeed from "../component/CustomNeed";

const ResponsiveAndMobileOptimized = () => {
    useEffect(() => {
    
        const win = window;
    
        function isElementVisible($el) {
          const viewTop = win.scrollY;
          const viewBottom = viewTop + window.innerHeight;
          const elTop = $el.offset().top;
          const elBottom = elTop + $el.height();
          return elBottom <= viewBottom && elTop >= viewTop;
        }
        $('.why_coustom_app').parents('body').find('header').addClass('white_header');  
        function addAnimation($el, delay) {
            
          setTimeout(() => {
            $el.addClass("come-in");
            $el.attr("class", "webflow_circle come-in");
          }, delay);
        }
    
        const allMods1 = Array.from(document.querySelectorAll(".webflow_circle"));
        const allMods2 = Array.from(document.querySelectorAll(".html_circle"));
        const allMods3 = Array.from(document.querySelectorAll(".css_circle"));
        const allMods4 = Array.from(document.querySelectorAll(".js_circle"));
    
        win.addEventListener("scroll", () => {
          allMods1.forEach((el, i) => {
            const $el = $(el);
            if (isElementVisible($el)) {
              addAnimation($el, i * 200);
            }
          });
    
          allMods2.forEach((el, i) => {
            const $el = $(el);
            if (isElementVisible($el)) {
              addAnimation($el, i * 200);
            }
          });
    
          allMods3.forEach((el, i) => {
            const $el = $(el);
            if (isElementVisible($el)) {
              addAnimation($el, i * 200);
            }
          });
    
          allMods4.forEach((el, i) => {
            const $el = $(el);
            if (isElementVisible($el)) {
              addAnimation($el, i * 200);
            }
          });
        });
    
        const handleScroll = () => {
          const offset = window.pageYOffset;
          const wheight = window.innerHeight;
          const html = document.documentElement;
          const docheight = Math.max(
            document.body.scrollHeight,
            document.body.offsetHeight,
            html.clientHeight,
            html.scrollHeight,
            html.offsetHeight
          );
          let progress = (offset / (docheight - wheight)) * 3000;
    
          // Give the line a CSS gradient based on scroll position
          progress = 3000 - progress * 1.6;
    
          // Update the SVG element with the new stroke-dashoffset
          const fillingPath = document.getElementById("filling_path");
          if (fillingPath) {
            fillingPath.setAttribute("stroke-dashoffset", progress);
          }
        };
    
        // Add scroll event listener when the component mounts
        window.addEventListener("scroll", handleScroll);
    
        // Remove the event listener when the component unmounts
        return () => {
            
          window.removeEventListener("scroll", handleScroll); 
        };
      }, []);
      const [ref, inView] = useInView({
        triggerOnce: true, // Ensures the animation occurs only once
        threshold: 0.2, // Change as needed; it's the percentage of the element's visibility to trigger the animation
      });
    
      const leftAnimation = {
        hidden: { opacity: 0, scale: 0, x: -200 },
        visible: {
          opacity: 1,
          scale: 1,
          x: 0,
          transition: { duration: 1, ease: "easeOut" }, // Define your desired animation properties
        },
      };
    
      const image1Animation = {
        hidden: { opacity: 0, scale: 0, x: -200 },
        visible: {
          opacity: 1,
          scale: 1,
          x: 0,
          transition: { duration: 1, ease: "easeOut", delay: 0.5 }, // Define your desired animation properties
        },
      };
    
      const image2Animation = {
        hidden: { opacity: 0, scale: 0, x: -200 },
        visible: {
          opacity: 1,
          scale: 1,
          x: 0,
          transition: { duration: 1, ease: "easeOut", delay: 1 }, // Define your desired animation properties
        },
      };
    
      const image3Animation = {
        hidden: { opacity: 0, scale: 0, x: -200 },
        visible: {
          opacity: 1,
          scale: 1,
          x: 0,
          transition: { duration: 1, ease: "easeOut", delay: 1.5 }, // Define your desired animation properties
        },
      };
       
      return (
        <>
          <div
            className="inner_banner service-banner"
            style={{ backgroundImage: "url(/assets/images/site/service-responsive.png)" }}
          >
            <div className="wrapper">
              <div className="banner_detail_1">
                <div className="details-ser">
                  <h1 id="heading_line">Responsive & Mobile-Optimized Designs</h1>
                  <h2 id="sub_heading1">
                  In today’s fast-paced digital world, *responsive* and *mobile-optimized designs* are no longer optional; they are essential. With the increasing use of smartphones, tablets, and other mobile devices to browse the web, creating a seamless experience across all platforms has become critical for businesses, content creators, and developers alike. Let's break down the importance of responsive and mobile-optimized designs, their benefits, and the best practices to follow.
                  </h2>
                </div>
              </div>
            </div>
          </div>
          <div className="why_coustom_app">
            <div className="wrapper">
              <h3>
              What is Responsive <span>Design ?</span>
              </h3>
              <p>
              Responsive web design* is an approach to web design that ensures a website’s layout adjusts to fit the screen size of the device being used to view it. This means that whether someone is accessing the site on a large desktop monitor, a tablet, or a small mobile phone, the content will be easily readable and usable, without the need for zooming or scrolling horizontally.

              </p>
              <h4>How Does Responsive Design Work?</h4>
              <p>
              Responsive design uses a combination of flexible grids, fluid images, and CSS media queries to create layouts that adapt to different screen sizes and orientations. Key components include:{" "}
              </p>
              <ul>
                <ul>
                  <li>
                    <b>Fluid Grid Layouts:</b> Instead of fixed pixel widths, elements are sized using relative units like percentages or ems. This ensures that the layout adapts to various screen sizes.
                  </li>
                  <li>
                    <b>Media Queries:</b> These CSS rules apply different styles based on the device’s characteristics, such as width, height, or orientation. For example, a two-column layout might become a single column layout on mobile devices.
                  </li>
                  <li>
                    <b>Flexible Images and Media:</b> Images and videos are set to adjust to the size of their container. They don’t break the layout, regardless of whether the site is being viewed on a large screen or a smaller mobile device.
                  </li>
                </ul>
              </ul>
              <h4>Key Features of Mobile-Optimized Design</h4>
              <ul>
                <li>
                  <b>Touchscreen-Friendly Navigation:</b> Mobile devices rely on touch, so buttons and links must be large enough to be tapped easily. Menus should be easy to access, and there should be a clear call-to-action.
                </li>
    
                <li>
                  <b>Fast Loading Speed:</b> Mobile users often experience slower internet connections compared to desktop users. Optimizing images, compressing files, and minimizing unnecessary elements is critical to ensure fast loading times.

                </li>
                <li>
                  <b>Prioritizing Content:</b> Mobile screens are smaller, so it’s essential to prioritize content. Important information should be visible immediately, and less crucial content can be hidden or minimized.
                  standards.
                </li>
                <li>
                  <b>Single Column Layout:</b> A single-column design is more suitable for mobile devices, as it reduces the need for horizontal scrolling and ensures that content is presented in a way that is easy to read and navigate.
                </li>
              </ul>
              <h4>What is Mobile-Optimized Design?</h4>
              <p>
              Mobile-optimized design specifically focuses on creating websites that are *tailored for mobile devices. While responsive design ensures that a website works well on any device, mobile optimization takes it a step further by providing a user-friendly, fast, and engaging experience on smartphones and tablets. It focuses on **performance, touch gestures, and ease of navigation* on small screens.
              </p>
              <h4>Why are Responsive and Mobile-Optimized Designs Important?</h4>
              <ul>
                <li><b>Better User Experience:</b>A well-designed, responsive website offers a seamless experience, whether on a desktop or mobile device. Visitors are more likely to stay on a site that is easy to navigate and loads quickly.</li>
                <li><b>Improved SEO Ranking:</b>Google’s mobile-first indexing prioritizes mobile-friendly websites for search engine rankings. Sites that are not mobile-optimized or responsive will likely see a drop in search engine visibility.</li>
                <li><b>Increased Conversions:</b>A mobile-optimized site increases the likelihood of conversions, whether those are purchases, form submissions, or other desired actions. Mobile users are more likely to take action when the experience is smooth and efficient.</li>
                <li><b>Wider Audience Reach:</b>By making your website responsive and mobile-friendly, you cater to a larger audience, as people are increasingly browsing and shopping via mobile devices. It also enhances accessibility for users with different needs.</li>
              </ul>
              <h4>Best Practices for Creating Responsive & Mobile-Optimized Designs</h4>
              <ul>
                <li><b>Use a Mobile-First Approach:</b>Start designing with mobile devices in mind. Since mobile users represent a large portion of web traffic, designing for them first can help streamline your design process.</li>
                <li><b>Keep It Simple and Clean:</b>Avoid clutter on mobile screens. Use minimalistic designs with clear, concise content. Focus on usability and readability by utilizing large fonts and sufficient white space.</li>
                <li><b>Optimize Media:</b>Compress images and videos to reduce loading times. Use formats like WebP for images and responsive videos that adjust based on the device’s screen size and resolution.</li>
                <li><b>Test Across Devices:</b>Ensure your site works well on a wide range of devices. Regularly test your site on different screen sizes and browsers to identify potential issues and areas for improvement.</li>
                <li><b>Ensure Easy Navigation:</b>Simplify navigation on mobile by using collapsible menus, sticky headers, and clearly defined buttons. Navigation should be intuitive and easy to reach with a thumb.</li>
                <li><b>Focus on Speed:</b>Mobile users expect fast-loading sites. Use performance tools like Google’s PageSpeed Insights to check your site’s loading speed and identify potential bottlenecks.</li>
                <li><b>Use Larger Touch Targets:</b> On mobile devices, ensure buttons and links are large enough to be tapped easily. Avoid placing clickable elements too close to each other, which can lead to accidental clicks.</li>
                <li><b>Implement Accelerated Mobile Pages (AMP):</b>AMP is an open-source framework that optimizes the performance of mobile pages. While not mandatory, implementing AMP can significantly enhance your website's mobile performance.</li>
              </ul>
              <h4>
              Conclusion
              </h4>
              <p>Responsive and mobile-optimized designs are not just trends; they are essential to providing a positive user experience and achieving online success. With mobile internet usage continually rising, businesses and websites that fail to implement responsive and mobile-optimized designs risk losing valuable traffic and conversions. By following best practices for responsive design and focusing on mobile optimization, you can ensure that your website delivers a seamless, engaging, and fast experience for all users, no matter the device they use.</p>
              <p>The future of web design is mobile-first, and embracing these principles will set you up for success in an increasingly mobile-driven world.</p>
            </div>
          </div>
          <div className="why_us">
            <div className="wrapper">
              <h4>Benefits of Working with CodeFlix</h4>
              <div className="col_row">
                <div
                  className="col_item"
                  style={{
                    backgroundImage: `url(./assets/images/portfolio/usbg1.svg)`,
                  }}
                >
                  <div className="icon">
                    <img src="./assets/images/portfolio/us5.svg" alt="" />
                  </div>
                  <hr />
                  <h3>End-to-End Solutions</h3>
                  <p>
                    From ideation to deployment, we handle every aspect of the
                    development process.
                  </p>
                </div>
                <div
                  className="col_item"
                  style={{
                    backgroundImage: `url(./assets/images/portfolio/usbg2.svg)`,
                  }}
                >
                  <div className="icon">
                    <img src="./assets/images/portfolio/us6.svg" alt="" />
                  </div>
                  <hr />
                  <h3>Agile Methodology</h3>
                  <p>
                    Ensuring flexibility and faster delivery without compromising on
                    quality.
                  </p>
                </div>
                <div
                  className="col_item"
                  style={{
                    backgroundImage: `url(./assets/images/portfolio/usbg3.svg)`,
                  }}
                >
                  <div className="icon">
                    <img src="./assets/images/portfolio/us7.svg" alt="" />
                  </div>
                  <hr />
                  <h3>Experienced Team</h3>
                  <p>
                    A skilled team of developers, designers, and project managers
                    dedicated to your success.
                  </p>
                </div>
                <div
                  className="col_item"
                  style={{
                    backgroundImage: `url(./assets/images/portfolio/usbg4.svg)`,
                  }}
                >
                  <div className="icon">
                    <img src="./assets/images/portfolio/us8.svg" alt="" />
                  </div>
                  <hr />
                  <h3>Client-Centric Approach</h3>
                  <p>
                    Regular communication and collaboration to align the project
                    with your vision.
                  </p>
                </div>
              </div>
           <br />
            </div>
                  </div>
                <div className="let_build">
                    <div className="wrapper">
                    <h4>Let’s Build <span> Your App Together </span></h4>
                  
                  <p>
                    Whether you’re a startup looking to disrupt the market or an
                    established enterprise aiming to enhance operational efficiency,
                    CodeFlix is here to bring your vision to life. Let’s create a
                    custom mobile app that drives results and delights your users.{" "}
                    <br />
                    Contact Us today to get started on your mobile app development
                    journey.
                  </p>
                    </div>
                </div>
        </>
      );
};
export default ResponsiveAndMobileOptimized;
